import React, { useState } from "react";
import { downloadJson } from "../utils/functions";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  InputAdornment,
  DialogActions,
  Button,
} from "@material-ui/core";

export default ({ close, isDownloadJsonOpen }) => {
  const [fileName, setFileName] = useState("features");
  return (
    <Dialog open={isDownloadJsonOpen} onClose={close}>
      <DialogTitle id="form-dialog-title">Download JSON</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="File Name"
          value={fileName}
          onChange={(e) => setFileName(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">.json</InputAdornment>
            ),
          }}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary">
          Cancel
        </Button>
        <Button
          onClick={() => {
            downloadJson(fileName);
            close();
          }}
          color="primary"
        >
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};
